module.exports = __webpack_public_path__ + "static/media/lo90.4ec0a2c0.png";